import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../app/store";
import EASkeletonLoader from "../../../app/components/shared/EASkeletonLoader";
import KrakowShopChanger from "./KrakowShopChanger";
import useFacility from "../../../utils/hooks/useFacility";
import LinkedFacilitiesSwitcher from "./LinkedFacilitiesSwitcher";

const NaviLogo: React.FC = () => {
  const logoUrl = useSelector((state: State) => state.config.facilityLogoUrl);
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const facilityIds = useFacility();
  const isB2B = Boolean(useSelector((state: State) => state.auth.userData.b2bType));

  if (!Boolean(logoUrl)) {
    return <EASkeletonLoader height="100px" />;
  } else {
    return (
      <>
        <a href={isB2B ? window.location.href : saleConfiguration.startPageUrl} target="_parent">
          <img src={logoUrl} alt="Logo sklepu" />
        </a>
        {!isB2B && <LinkedFacilitiesSwitcher />}
        {!isB2B && (facilityIds === "1243" || facilityIds === "1241") && <KrakowShopChanger />}
      </>
    );
  }
};

export default NaviLogo;
